import styled from 'styled-components';

export const StyledContent = styled.span`
  cursor: help;
`;

export const StyledTooltipContent = styled.pre`
  margin: 0;
`;
